import { fetchRotatingSegmentTitlesApi } from 'support/api/RotatingSegmentTitlesApi';
import { HttpClient } from 'support/api/api-types';

export const ROTATING_SEGMENT_TITLES = 'ROTATING_SEGMENT_TITLES' as const;
export const ADD_ROTATING_SEGMENT_ID = 'ADD_ROTATING_SEGMENT_ID' as const;
export const DELETE_ROTATING_SEGMENT_ID = 'DELETE_ROTATING_SEGMENT_ID' as const;

export const fetchRotatingSegmentTitles = () => {
  return {
    type: ROTATING_SEGMENT_TITLES,
    promise: (httpClient: HttpClient) => fetchRotatingSegmentTitlesApi(httpClient),
  };
};

export const addRotatingSegmentTitleId = (rotatingSegmentId?: string) => ({
  type: ADD_ROTATING_SEGMENT_ID,
  payload: {
    id: rotatingSegmentId,
  },
});

export const deleteRotatingSegmentTitleId = (rotatingSegmentId: string) => ({
  type: DELETE_ROTATING_SEGMENT_ID,
  payload: {
    id: rotatingSegmentId,
  },
});
